import { Column } from '@tanstack/react-table';
import { CSSProperties } from 'react';

export const getPinningStyles = <TData = unknown>(column: Column<TData>): CSSProperties => {
  const isPinned = column.getIsPinned();
  return {
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    position: isPinned ? 'sticky' : 'relative',
    zIndex: isPinned ? 1 : 0,
  };
};
